import { $post, $api } from '@/service/request';

export default {
	namespaced: true,
	state: () => ({
		// 磁贴活动信息
		activityInfo: {},
		// 新闻任务列表
		newslist: [],
		gridList: [],
		horizList: [],
		// 宝箱进度列表
		pointlist: [],
		// v1.1 宝箱进度列表
		pointList: [],
		abInfo: {
			feedAdShowAb: 'a',
			chestVideoAb: 'a',
		},
		detentionWindow: {
			coins: 1700,
			title: '请你留下啊，还有1700金币没领取',
			expire_time: 1800, // 倒计时
		},
		feedAdId: 0,
		chestVideo: {
			ad_group_id: 1,
			task_type: 'view_news_chest',
		},
		resource: {
			top_banner: '',
		},
		businessName: '',
		businessNameSignVideo: '',
		businessNameSignVideOver: '',
		isNewVersion: null,
		signInfo: {}, // 每日签到弹窗信息
		videoFrom: '',
		viewNewsAb: '',
		viewNewsLayoutAb: '',
		titleInfo: {
			title: '看新闻得金币',
		},
		ruleList: [],
		coins: 0,
	}),
	mutations: {
		setActivityInfo(state, data) {
			state.activityInfo = data;
		},
		setNewlist(state, data) {
			console.log(`setNewlist`, data);
			let gridList = [],
				horizList = [];
			if (data.length) {
				data.forEach((news) => {
					if (news.show_style && news.show_style === 'grid') {
						gridList.push(news);
					} else if (news.show_style && news.show_style === 'horizonal') {
						horizList.push(news);
					} else {
						gridList.push(news);
					}
				});
			}

			state.gridList = gridList;
			state.horizList = horizList;
			state.newslist = data;
		},
		setPointlist(state, data) {
			state.pointlist = [...data];
		},
		SET_POINT_LIST(state, data) {
			state.pointList = [...data];
		},
		SET_TITLE_INFO(state, data) {
			state.titleInfo = { ...data };
		},
		SET_RULE_LIST(state, data) {
			state.ruleList = [...data];
		},
		setAdInfo(state, data) {
			state.adInfo = { ...data };
		},
		setAbInfo(state, data) {
			state.abInfo = { ...data };
		},
		setDetentionWindow(state, data) {
			state.detentionWindow = { ...data };
		},
		setFeedAdId(state, payload) {
			state.feedAdId = payload;
		},
		setChestVideo(state, data) {
			state.chestVideo = { ...data };
		},

		setResource(state, data) {
			state.resource = { ...data };
		},

		setBusinessName(state, payload) {
			state.businessName = payload;
		},
		SET_BUSINESS_NAME_SIGN_VIDEO(state, payload) {
			state.businessNameSignVideo = payload;
		},
		SET_BUSINESS_NAME_SIGN_VIDEO_OVER(state, payload) {
			state.businessNameSignVideOver = payload;
		},
		SET_READ_DURATION(state, payload) {
			state.duration = payload;
		},
		SET_IS_NEW_VERSION(state, payload) {
			state.isNewVersion = payload;
		},
		SET_SIGN_INFO(state, payload) {
			state.signInfo = payload;
		},
		SET_VIDEO_FROM(state, payload) {
			state.videoFrom = payload;
		},
		SET_VIEW_NEWS_AB(state, payload) {
			state.viewNewsAb = payload;
		},
		SET_VIEW_NEWS_LAYOUT_AB(state, payload) {
			console.log(`SET_VIEW_NEWS_LAYOUT_AB`, payload);
			state.viewNewsLayoutAb = payload;
		},
		SetCoins(state, payload) {
			state.coins = payload;
		},
	},
	actions: {
		async getNewsPageInfo({ commit }) {
			// 从服务端获取数据
			const { data } = await $post($api.NEWS_GET_PAGE_INFO, {});
			let {
				activity,
				task_list,
				chest_list,
				task_rules: { view_news_duration, rule_docs },
				business_name,
				business_name_sign_video,
				business_name_sign_video_over,
				detention_window,
				feed_ad_id,
				chest_video,
				feed_ad_show_ab,
				chest_video_ab,
				resource,
				is_new_version,
				view_news_v2_ab,
				view_news_v1_2_ab,
				news: titleInfo,
				task_accruing_coin,
			} = data;
			if (activity) {
				commit('setActivityInfo', activity);
			}
			if (view_news_v2_ab === 'a') {
				chest_list.unshift({
					chest_id: 0,
					coins: 200,
					status: 2,
					task_num: 0,
					type: 'sign',
				});

				commit('SET_POINT_LIST', chest_list);
				commit('SET_TITLE_INFO', titleInfo);
			} else {
				commit('setPointlist', chest_list);
			}
			commit('SET_RULE_LIST', rule_docs);
			commit('setAbInfo', {
				feedAdShowAb: feed_ad_show_ab,
				chestVideoAb: chest_video_ab,
			});
			commit('setDetentionWindow', detention_window);
			commit('setFeedAdId', feed_ad_id);
			commit('setChestVideo', chest_video);
			commit('setResource', resource);
			commit('setBusinessName', business_name);
			commit('SET_BUSINESS_NAME_SIGN_VIDEO', business_name_sign_video);
			commit('SET_BUSINESS_NAME_SIGN_VIDEO_OVER', business_name_sign_video_over);
			commit('SET_READ_DURATION', view_news_duration);
			commit('SET_IS_NEW_VERSION', is_new_version);
			commit('SET_VIEW_NEWS_AB', view_news_v2_ab);
			commit('SET_VIEW_NEWS_LAYOUT_AB', view_news_v1_2_ab);
			commit('SetCoins', task_accruing_coin);
			commit('setNewlist', task_list);
		},
	},
	getters: {
		showFeed(state) {
			const { abInfo } = state;
			const { feedAdShowAb } = abInfo;
			return feedAdShowAb === 'b';
		},
		showChestVideo(state) {
			const { abInfo } = state;
			const { chestVideoAb } = abInfo;
			return chestVideoAb === 'b';
		},
		// 完成的任务数
		completedTaskCount(state) {
			const { newslist } = state;
			return newslist.filter((item) => +item.status === 2 || +item.status === 3).length;
		},
		READ_DURATION(state) {
			return state.duration;
		},
		IS_NEW_VERSION(state) {
			return state.isNewVersion;
		},
		ACTIVITY_INFO(state) {
			return state.activityInfo;
		},
		SIGN_INFO(state) {
			return state.signInfo;
		},
		VIDEO_FROM(state) {
			return state.videoFrom;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/ActivityPage/modules/news.js